import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ImporterService } from 'src/app/core/services/importer.service';

@Component({
  selector: 'app-imports',
  templateUrl: './imports.component.html',
  styleUrls: ['./imports.component.css'],
})
export class ImportsComponent implements OnInit {
  imports: any;
  isLoading: boolean = false;
  selectedImport: any;

  page = 1;
  perPage = 9;

  deleteModal: any;
  private dialogOptions: NgbModalOptions = {
    backdropClass: 'dark-backdrop',
    centered: true,
    windowClass: 'window-modal',
  };

  constructor(
    private importService: ImporterService,
    private route: ActivatedRoute,
    private router: Router,
    private modalService: NgbModal
  ) {}

  ngOnInit(): void {
    this.loadImports();
  }

  loadImports() {
    this.isLoading = true;
    this.importService.getAllImports().subscribe((res) => {
      this.imports = res;
      this.isLoading = false;
    });
  }

  // Helper function to parse message into key-value pairs
  parseMessage(message: string): any[] {
    const lines = message
      .split('\n')
      .filter(
        (line) =>
          line.trim() !== '' &&
          !line.startsWith('Vin information not matched in importer.')
      );
    const parsedData = lines.map((line) => {
      const [key, value] = line.split(':').map((item) => item.trim());

      // If value is undefined or empty, set it to '/'
      const finalValue = value !== 'undefined' ? value : '/';

      // Adjusting key labels for certain fields
      const labelMap: { [key: string]: string } = {
        modelYear: 'Model Year',
        bodyType: 'Body Type',
        fuelType: 'Fuel Type',
        horsePower: 'Horse Power',
        engineSize: 'Engine Size',
        userName: 'User Name',
        userEmail: 'User Email',
      };

      // Replace key with adjusted label if it exists in labelMap
      const displayKey =
        labelMap[key] ||
        key.charAt(0).toUpperCase() + key.slice(1).replace(/([A-Z])/g, ' $1');
      return { key: displayKey, value: finalValue };
    });
    return parsedData;
  }

  navigateToVehicle(event: any) {
    this.router.navigate(
      [`/root/users/${event.user.id}/vehicles/${event.vehicleId}`],
      {
        relativeTo: this.route,
        queryParamsHandling: 'preserve',
      }
    );
  }

  jumpToPage(event: any) {
    this.page = event;
  }

  openDeleteModal(content, item) {
    this.selectedImport = item;
    this.deleteModal = this.modalService.open(content, this.dialogOptions);
  }

  deleteImport() {
    this.importService
      .deleteImports(this.selectedImport.id)
      .subscribe((res) => {
        this.loadImports();
        this.deleteModal.close();
      });
  }
}
